export default "__VITE_ASSET__DnJ9SpgQ__"